import gsap, { Power1, Power3 } from "gsap";

import { GetBy } from "../_app/cuchillo/core/Element";
import { isDebug } from '../_app/cuchillo/core/Basics';
import { Ease } from "../_app/cuchillo/utils/Ease";
import { Metrics } from "../_app/cuchillo/core/Metrics";

export default class Preloader {
    _container;
    _progress;

    static init() {
        if (isDebug) {
            GetBy.id('Preloader').style.display = "none";
            return;
        }

        this._container = GetBy.id('Preloader');
        this._logo = GetBy.class('logo', this._container)[0];
        this._main = GetBy.selector('.block-billboard > .cover')[0];
        this._main2 = GetBy.selector('.block-billboard > .holder')[0];
        this._header = GetBy.id('Header');

        gsap.to(this._logo, {
            opacity: 1,
            ease: Power3.easeOut,
            duration: .4
        });
    }

    static update(__progress) {
        if (isDebug) return;
    }

    static hide(__call) {
        if (isDebug) {
            if (__call) __call();
            return;
        }

        gsap.killTweensOf(this._logo);

        gsap.to(this._logo, {
            opacity: 0,
            ease: Power3.easeIn,
            duration: .2,
        });

        gsap.from([this._header], {
            y: Metrics.CENTER_Y,
            duration: .9,
            ease: Ease.EASE_CUCHILLO_OUT,
            delay: 0
        });

        if(this._main) {
            gsap.from([this._main], {
                y: Metrics.CENTER_Y,
                duration: 1,
                ease: Ease.EASE_CUCHILLO_OUT,
                delay: .1
            });
        }

        if(this._main2) {
            gsap.from([this._main2], {
                y: Metrics.CENTER_Y,
                duration: 1.1,
                ease: Ease.EASE_CUCHILLO_OUT,
                delay: .2
            });
        }

        gsap.to(this._container, {
            scaleY: 0,
            duration: .8,
            ease: Ease.EASE_CUCHILLO_IN_OUT,
            delay: .1,
            onComplete: () => {
                this._container.style.display = "none";
                if (__call) __call();
            }
        });
    }
}
